"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "finnFelttype", {
    enumerable: true,
    get: function() {
        return finnFelttype;
    }
});
var felttyper = [
    {
        navn: "Tekst",
        valideringer: []
    },
    {
        navn: "Positivt heltall",
        valideringer: [
            "positiveHeltall"
        ]
    },
    {
        navn: "Bel\xf8p som positivt heltall",
        valideringer: [
            "positiveHeltall",
            "maksLengdeForBeloep"
        ],
        transformer: {
            id: "tall"
        }
    },
    {
        navn: "Verdi som prosent",
        valideringer: [
            "validerProsent"
        ],
        transformer: {
            id: "prosent"
        }
    },
    {
        navn: "Obligatorisk",
        valideringer: [
            "obligatorisk"
        ]
    }
];
var finnFelttype = function(navn) {
    return felttyper.filter(function(x) {
        return x.navn === navn;
    })[0];
};
